class ImageSlider extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector('.image-slider__track');
    this.dots = [...this.querySelectorAll('.image-slider__dot')];
    this.slides = [...this.querySelectorAll('.image-slider__slide')];
    this.prevBtn = this.querySelector('.image-slider__arrow--prev');
    this.nextBtn = this.querySelector('.image-slider__arrow--next');
    this.index = 0;
    this.autoplayDelay = (parseFloat(this.style.getPropertyValue('--autoplay-delay')) || 4) * 1000;
    this.isDragging = false;
    this.dragStartX = 0;
    this.dragStartScroll = 0;
    this.dragMoved = false;
  }

  connectedCallback() {
    this.dots.forEach((dot, i) => {
      dot.addEventListener('click', () => this.goTo(i));
    });

    this.prevBtn?.addEventListener('click', () => this.step(-1));
    this.nextBtn?.addEventListener('click', () => this.step(1));

    this.track.addEventListener('scroll', () => this.onScroll(), { passive: true });

    this.track.addEventListener('mousedown', (e) => this.onDragStart(e));
    window.addEventListener('mousemove', (e) => this.onDragMove(e));
    window.addEventListener('mouseup', () => this.onDragEnd());
    this.track.addEventListener('click', (e) => this.onClickCapture(e), true);

    if (this.hasAttribute('autoplay')) {
      this.start();
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
    }

    this.updateDots();
  }

  step(direction) {
    const next = (this.index + direction + this.slides.length) % this.slides.length;
    this.goTo(next);
  }

  onDragStart(e) {
    this.isDragging = true;
    this.dragMoved = false;
    this.dragStartX = e.pageX;
    this.dragStartScroll = this.track.scrollLeft;
    this.track.classList.add('is-dragging');
  }

  onDragMove(e) {
    if (!this.isDragging) return;
    const delta = e.pageX - this.dragStartX;
    if (Math.abs(delta) > 5) this.dragMoved = true;
    this.track.scrollLeft = this.dragStartScroll - delta;
  }

  onDragEnd() {
    if (!this.isDragging) return;
    this.isDragging = false;
    this.track.classList.remove('is-dragging');
    const width = this.track.clientWidth;
    const nearest = Math.round(this.track.scrollLeft / width);
    this.goTo(Math.max(0, Math.min(nearest, this.slides.length - 1)));
  }

  onClickCapture(e) {
    // Prevent a link/nav click from firing right after a drag
    if (this.dragMoved) {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  disconnectedCallback() {
    this.stop();
  }

  onScroll() {
    const width = this.track.clientWidth;
    this.index = Math.round(this.track.scrollLeft / width);
    this.updateDots();
  }

  updateDots() {
    this.dots.forEach((dot, i) => {
      dot.setAttribute('aria-current', i === this.index ? 'true' : 'false');
    });
  }

  goTo(i) {
    this.index = i;
    this.track.scrollTo({
      left: this.slides[i].offsetLeft,
      behavior: 'smooth',
    });
  }

  start() {
    this.stop();
    this.timer = setInterval(() => {
      const next = (this.index + 1) % this.slides.length;
      this.goTo(next);
    }, this.autoplayDelay);
  }

  stop() {
    if (this.timer) clearInterval(this.timer);
  }
}

customElements.define('image-slider', ImageSlider);
